var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuiNguoiNopThueed63Eecd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4374",
    "data-name": "Ellipse 4374",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(0 0)",
    fill: "#f5f8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.909,
    y1: 1,
    x2: 0.294,
    y2: -0.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7edfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.326,
    x2: 0.71,
    y2: 0.547,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d42371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f24d96",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GuiNguoiNopThue",
    transform: "translate(-892 -293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53141",
    "data-name": "Group 53141",
    transform: "translate(11518 5867)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4372",
    "data-name": "Ellipse 4372",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-10626 -5574)",
    fill: "#f5f9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-10626 -5574)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53139",
    "data-name": "Group 53139",
    transform: "translate(12.112 23.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22825",
    "data-name": "Rectangle 22825",
    width: 51.072,
    height: 60.294,
    rx: 4,
    transform: "translate(2 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22802",
    "data-name": "Rectangle 22802",
    width: 22.837,
    height: 3.901,
    rx: 1.95,
    transform: "translate(5.14 4.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22803",
    "data-name": "Rectangle 22803",
    width: 13.425,
    height: 3.901,
    rx: 1.95,
    transform: "translate(5.14 10.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22804",
    "data-name": "Rectangle 22804",
    width: 40.309,
    height: 4.169,
    rx: 2.085,
    transform: "translate(5.14 20.562)",
    fill: "#73d0f8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22805",
    "data-name": "Rectangle 22805",
    width: 21.909,
    height: 4.169,
    rx: 2.085,
    transform: "translate(5.14 27.62)",
    fill: "#73d0f8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_75984",
    "data-name": "Path 75984",
    d: "M1.2,12.534C5.844,10.545,9.449,1.388,4.891.808-.574.112.457,12.037,4.642,11.332s9.572-5.539,6.671-6.8c-3.729-1.616-3.854,6.174-1.16,6.505S13.1,7.23,14.214,7.23s-.249,3.066,1.45,2.859.746-3.356,2.528-3.356",
    transform: "translate(19.258 56.563)",
    fill: "none",
    stroke: "#007aff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53229",
    "data-name": "Group 53229",
    transform: "translate(946 346.961)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4390",
    "data-name": "Ellipse 4390",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(0 0.039)",
    fill: "#f24d96",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76011",
    "data-name": "Path 76011",
    d: "M46.313,446.167,41.661,441l-5.026,5.167-2.947-3.1-3.861,5.408,9.511,7.728Z",
    transform: "translate(-20.378 -432.206)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53210",
    "data-name": "Group 53210",
    transform: "translate(9.083 8.175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22837",
    "data-name": "Rectangle 22837",
    width: 13,
    height: 9,
    rx: 2,
    transform: "translate(-0.083 -0.136)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53211",
    "data-name": "Group 53211",
    transform: "translate(4.042 11.808)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22838",
    "data-name": "Rectangle 22838",
    width: 4,
    height: 1,
    rx: 0.5,
    transform: "translate(-0.043 0.231)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53212",
    "data-name": "Group 53212",
    transform: "translate(5.861 13.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22839",
    "data-name": "Rectangle 22839",
    width: 2,
    height: 1,
    rx: 0.5,
    transform: "translate(0.139 0.344)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53213",
    "data-name": "Group 53213",
    transform: "translate(1 13.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22840",
    "data-name": "Rectangle 22840",
    width: 3,
    height: 1,
    rx: 0.5,
    transform: "translate(1 0.344)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_76012",
    "data-name": "Path 76012",
    d: "M49.014,444l1.1.7-.241,5.315L43.943,447Z",
    transform: "translate(-28.407 -434.133)",
    opacity: 0.14,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76013",
    "data-name": "Path 76013",
    d: "M33,444l4.3,2.456a1.43,1.43,0,0,0,1.42,0l4.3-2.456",
    transform: "translate(-22.626 -434.133)",
    fill: "none",
    stroke: "#f24d96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuiNguoiNopThueed63Eecd);
export default __webpack_public_path__ + "static/media/GuiNguoiNopThue.ed63eecd.5584866928202b82a20561efc9aaa22e.svg";
export { ForwardRef as ReactComponent };